import { Component, Input, OnInit } from '@angular/core';
import { WorkshopRegistrationRequestModel } from '../../models/workshop-registration-request.model';
import { PersianTitlesService } from '../../../core/services/persian-titles.service';

@Component({
  selector: 'app-workshop-registration-request-card',
  templateUrl: './workshop-registration-request-card.component.html',
  styleUrls: ['./workshop-registration-request-card.component.css'],
  standalone: false,
})
export class WorkshopRegistrationRequestCardComponent implements OnInit {
  @Input('workshopRegistrationRequest')
  request: WorkshopRegistrationRequestModel;

  // Labels
  teacherLabel: string = '';
  holdingTypeLabel: string = '';
  holdingDateLabel: string = '';
  locationLabel: string = '';
  daysLeftLabel: string = '';
  requestDateLabel: string = '';
  statusLabel: string = '';

  constructor(private persianTitlesService: PersianTitlesService) {}

  ngOnInit() {
    this.initLabel();
  }

  private initLabel() {
    this.teacherLabel = this.persianTitlesService.Items.Teacher;
    this.holdingDateLabel = this.persianTitlesService.Items.HoldingDate;
    this.holdingTypeLabel = this.persianTitlesService.Items.HoldingType;
    this.locationLabel = this.persianTitlesService.Items.Location;
    this.requestDateLabel = this.persianTitlesService.Items.RequestDate;
    this.statusLabel = this.persianTitlesService.Items.RegistrationStatus;
    this.daysLeftLabel = this.persianTitlesService.Items.DaysLeft;
  }
}
